exports.componentPropsPlugin = require('../lib/next-config/plugins/component-props');
exports.corsHeaderPlugin = require('../lib/next-config/plugins/cors-header');
exports.disconnectedPlugin = require('../lib/next-config/plugins/disconnected');
exports.feaasPlugin = require('../lib/next-config/plugins/feaas');
exports.graphqlPlugin = require('../lib/next-config/plugins/graphql');
exports.robotsPlugin = require('../lib/next-config/plugins/robots');
exports.sitemapPlugin = require('../lib/next-config/plugins/sitemap');
